import React from "react";
import { AlertTriangle, Clock } from "lucide-react";

/**
 * Avviso in cima alla scelta delle risorse: chi è stato selezionato ma in
 * quei giorni non c'è. Senza questo l'unico modo di accorgersene era leggere
 * riga per riga l'elenco del personale, e in pianificazione nemmeno quello.
 *
 * Distingue chi manca del tutto da chi ha solo un permesso a ore: il secondo
 * resta assegnabile, va solo saputo.
 */
export default function AvvisoIndisponibili({ assenti = [], parziali = [], contesto = "" }) {
  if (assenti.length === 0 && parziali.length === 0) return null;

  return (
    <div className="space-y-2" data-testid="avviso-indisponibili">
      {assenti.length > 0 && (
        <div className="rounded border border-red-300 bg-red-50 p-3">
          <div className="flex items-start gap-2">
            <AlertTriangle className="w-5 h-5 text-red-600 flex-shrink-0 mt-0.5" />
            <div className="min-w-0">
              <div className="font-semibold text-sm text-red-900">
                {assenti.length === 1
                  ? "Hai selezionato una persona non disponibile"
                  : `Hai selezionato ${assenti.length} persone non disponibili`}
                {contesto && <span className="font-normal"> {contesto}</span>}
              </div>
              <div className="flex flex-wrap gap-1.5 mt-2">
                {assenti.map(a => (
                  <span key={a.id || a.employee_id}
                        className="text-xs bg-white border border-red-200 rounded px-2 py-1">
                    <strong>{a.full_name || a.employee_name}</strong>
                    {a.etichetta && <span className="text-red-700"> · {a.etichetta}</span>}
                    {a.periodo && <span className="text-slate-500"> · {a.periodo}</span>}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}

      {parziali.length > 0 && (
        <div className="rounded border border-amber-300 bg-amber-50 p-3">
          <div className="flex items-start gap-2">
            <Clock className="w-5 h-5 text-amber-600 flex-shrink-0 mt-0.5" />
            <div className="min-w-0">
              <div className="font-semibold text-sm text-amber-900">
                Disponibilità parziale
              </div>
              <div className="flex flex-wrap gap-1.5 mt-2">
                {parziali.map(a => (
                  <span key={a.id || a.employee_id}
                        className="text-xs bg-white border border-amber-200 rounded px-2 py-1">
                    <strong>{a.full_name || a.employee_name}</strong>
                    <span className="text-amber-700">
                      {" · "}{a.etichetta || "permesso"}
                      {a.ora_inizio && ` ${a.ora_inizio}–${a.ora_fine}`}
                    </span>
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
